import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material'
import { UserModel } from '../../../models/user.model'
import { LoginMethods } from '../../../models/login-methods.model'

@Component({
  selector: 'app-retrieved-login-credentials-dialog',
  templateUrl: './retrieved-login-credentials-dialog.component.html',
})
export class RetrievedLoginCredentialsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<RetrievedLoginCredentialsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { user: UserModel; loginMethods: LoginMethods },
  ) {}

  onNoClick(): void {
    this.dialogRef.close()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/users/retrieved-login-credentials-dialog/retrieved-login-credentials-dialog.component.ts